const logs = {
	title: "Logs",
	id: "ID",
	user_id: "User",
	action: "Action",
	action_model: "Action Model",
	action_id: "Action ID",
	record: "Record",
	ip_address: "IP Address",
	created_at: "Date Created",
};
export default logs;